// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class DocumentService {
   $filter: any
   config: any
   detailConfig: any
   docConfig: any
   linkResolver: any
   localizeDate: any
   translationService: any
   utils: any
   quickLookService: any
   configService: any
   journalCoverageDetailsService: any
   
   constructor(config: any, $filter: any, translationService: any, utils: any, quickLookService:QuickLookService,
      configService: ConfigService, journalCoverageDetailsService: JournalCoverageDetailsService) {
      this.displayDetailPage = this.displayDetailPage.bind(this)
      this.getCatalogLink = this.getCatalogLink.bind(this)
      this.displayAIPage = this.displayAIPage.bind(this)
      this.getReserveLinkInfo = this.getReserveLinkInfo.bind(this)
      this.getIllRequestLink = this.getIllRequestLink.bind(this)
      this.getLinkResolver = this.getLinkResolver.bind(this)
      this.getComputedValues = this.getComputedValues.bind(this)
      this.getJournalTitleSearchLink = this.getJournalTitleSearchLink.bind(this)
      this.showDocumentGlanceability = this.showDocumentGlanceability.bind(this)
      this.getDocumentGlancebilityIcon = this.getDocumentGlancebilityIcon.bind(this)
      this.displayWarningGlanceability = this.displayWarningGlanceability.bind(this)
      this.getWarningGlanceabilityPublications = this.getWarningGlanceabilityPublications.bind(this)
      this.getWarningGlanceabilityNotices = this.getWarningGlanceabilityNotices.bind(this)
      this.checkGlanceabilityEnablmentFromCustomizer = this.checkGlanceabilityEnablmentFromCustomizer.bind(this)
      this.displaySecondaryPublicationsTypesSeparator = this.displaySecondaryPublicationsTypesSeparator.bind(this)
      this.displaySecondaryNoticeTypesSeparator = this.displaySecondaryNoticeTypesSeparator.bind(this)
      this.showVideoLink = this.showVideoLink.bind(this)
      this.getVideoLink = this.getVideoLink.bind(this)
      this.getDocumentSummary = this.getDocumentSummary.bind(this)
      this.getSimpleTitle = this.getSimpleTitle.bind(this)
      this.config = config
      this.$filter = $filter
      this.translationService = translationService
      this.utils = utils
      this.docConfig = this.config.data.document
      this.detailConfig = this.config.data.detailPage
      this.linkResolver = this.config.data.bxRecommender.linkResolver
      // filter functions
      this.localizeDate = this.$filter("summonDate")
      this.quickLookService = quickLookService
      this.configService = configService
      this.journalCoverageDetailsService = journalCoverageDetailsService
   }

   static readonly DIRECT_LINK_CONTENT_TYPES = [
      "eBook", "eJournal", "Journal", "Web Resource", "Streaming Audio", "Streaming Video"
   ]

   displayDetailPage(doc: any) {
      if (doc == null) { return }
      const uris = doc.uris || []
      const isDirectLinkContentType = DocumentService.DIRECT_LINK_CONTENT_TYPES.includes(doc.content_type)
      if (isDirectLinkContentType && uris.length === 1) { 
         return false 
      }
      const peerSourceTypes = _.pluck(doc.peer_documents, 'source_types')
      return this.docConfig.enableDetailPage && doc.source_types &&
         doc.source_types.includes("Library Catalog") &&
         (_.some(peerSourceTypes, (st: any) => st.includes("Library Catalog")) ||
            !peerSourceTypes.length || (uris.length != 1))
   }

   getCatalogLink(docs: any) {
      if (docs == null) { return }
      const catalogDoc = _.find(docs, (d: any) => d.source_types.includes("Library Catalog") && !d.has_fulltext)
      if (catalogDoc != null) { return catalogDoc.link }
   }

   displayAIPage(doc: any) {
      if (doc != null) {
         return this.docConfig.enableAIPage && doc.is_a_i
      } else {
         return false
      }
   }

   getAuthors(doc: any) {
      // use Corporate Authors if Authors field is empty
      if ((doc.authors != null) && doc.authors.length) {
         return doc.authors
      } else {
         return doc.corporate_authors
      }
   }

   getReserveLinkInfo(doc: any) {
      let reservable = false
      let clickTrackLink = true
      let reserveLink = ""
      if (this.detailConfig.enableReserveLinks) {
         if (!doc.reserve_link_url || !doc.reserve_link_url.url) {
            const {
               reserveLinks
            } = this.detailConfig
            // get first dbid associated w/doc that has a reserveLink URL in the client config
            const dbid = _.chain(reserveLinks).keys().intersection(_.pluck(doc.databases, 'dbid')).first().value()
            if (dbid && doc.external_document_id) {
               let match
               clickTrackLink = false
               reservable = true

               // use custom replace logic if it exists
               const regexString = "{{(id|encodedId)(\.replace\([^}]+\))}}"
               const customReplace = new RegExp(regexString)
               if (match = reserveLinks[dbid].match(customReplace)) {
                  let modifiedId = match[2] ? eval(`\"${doc.external_document_id}\"${match[2]}`) : doc.external_document_id
                  if (match[1].match(/encodedId/)) { modifiedId = encodeURIComponent(modifiedId) }
                  reserveLink = reserveLinks[dbid].replace(new RegExp(regexString, 'g'), modifiedId)
               } else {
                  reserveLink = reserveLinks[dbid]
                     .replace(/{{id}}/g, doc.external_document_id)
                     .replace(/{{encodedId}}/g, encodeURIComponent(doc.external_document_id))
               }
            } else {
               reservable = doc.from_library || false
               reserveLink = doc.link || ''
            }
         } else {
            reservable = true
            reserveLink = doc.reserve_link_url.url
         }
      }
      return [reservable, reserveLink, clickTrackLink]
   }

   getIllRequestLink(doc: any) {
      if (this.detailConfig.enableIll && this.detailConfig.illBaseUrl && doc.open_url) {
         const baseUrl = this.detailConfig.illBaseUrl.trim().replace(/\?$/, "")
         const delim = baseUrl.includes("?") ? "&" : "?"
         return `${baseUrl}${delim}${doc.open_url}`
      } else {
         return ""
      }
   }

   getLinkResolver(doc: any) {
      if (this.linkResolver && doc.open_url) {
         const baseUrl = this.linkResolver.trim().replace(/\?$/, "")
         const delim = baseUrl.includes("?") ? "&" : "?"
         return `${baseUrl}${delim}${doc.open_url}`

      } else {
         return ""
      }
   }

   // used in MoreDetails directive for transforming various document fields
   getComputedValues(doc: any) {
      const vals = {}

      // compute transliteration fields
      const enableTrans = this.detailConfig.enableTransliterations
      // @ts-expect-error TS(2339) FIXME: Property 'titles' does not exist on type '{}'.
      vals.titles = _.compact(enableTrans ? [doc.title].concat(doc.document_titles_fl) : [doc.title])
      // @ts-expect-error TS(2339) FIXME: Property 'subtitles' does not exist on type '{}'.
      vals.subtitles = _.compact(enableTrans ? [doc.subtitle].concat(doc.document_subtitles_fl) : [doc.subtitle])
      // @ts-expect-error TS(2339) FIXME: Property 'publicationTitles' does not exist on typ... Remove this comment to see the full error message
      vals.publicationTitles = _.compact(enableTrans ? [doc.publication_title].concat(doc.publication_titles_fl) : [doc.publication_title])
      // @ts-expect-error TS(2339) FIXME: Property 'editions' does not exist on type '{}'.
      vals.editions = _.compact(enableTrans ? (doc.editions || []).concat(doc.editions_fl) : doc.editions)

      // compute pages and page count fields
      // @ts-expect-error TS(2339) FIXME: Property 'pages' does not exist on type '{}'.
      vals.pages = {
         label: (doc.content_type && (doc.content_type.toLowerCase() !== 'dissertation')) && (doc.start_pages || []).length && (!(doc.end_pages || []).length || (_.first(doc.start_pages) === _.first(doc.end_pages))) ?
            "Start Page"
            :
            "Pages",
         value: doc.pages
      }
      // @ts-expect-error TS(2339) FIXME: Property 'pageCount' does not exist on type '{}'.
      if (doc.page_count !== doc.pages) { vals.pageCount = doc.page_count }

      // translate languages
      // @ts-expect-error TS(2339) FIXME: Property 'languages' does not exist on type '{}'.
      vals.languages = _.map(doc.languages, (lang: any) => this.translationService.translate(lang))
      return vals
   }

   getJournalTitleSearchLink(doc: any) {
      if ('Journal Article' !== doc.content_type) { return }
      const v = []
      if (doc.publication_date != null) { v.push(this.localizeDate(doc.publication_date)) }
      if ((doc.volumes != null) && doc.volumes.length) { v.push(`${this.translationService.translations.VOLUME} ${doc.volumes[0]}`) }
      if ((doc.issues != null) && doc.issues.length) { v.push(`${this.translationService.translations.ISSUE} ${doc.issues[0]}`) }

      const val = {}
      // @ts-expect-error TS(2339) FIXME: Property 'title' does not exist on type '{}'.
      val.title = doc.publication_title
      // @ts-expect-error TS(2339) FIXME: Property 'description' does not exist on type '{}'... Remove this comment to see the full error message
      val.description = v.join(', ')
      return val
   }

   showDocumentGlanceability(sourceType: any) {
      if (!this.checkGlanceabilityEnablmentFromCustomizer())
         return false
      if (sourceType === "review_article") {
         return this.translationService.translations.GLANCEABILITY_REVIEW_ARTICLE
      }
      if (sourceType === "primary_source") {
         return this.translationService.translations.GLANCEABILITY_PRIMARY_SOURCE
      }
      if (sourceType === "preprint") {
         return this.translationService.translations.GLANCEABILITY_PRE_PRINT
      }
      if (sourceType === "online_first") {
         return this.translationService.translations.GLANCEABILITY_ONLINE_FIRST
      }
      if (sourceType === "open_educational_resource") {
         return this.translationService.translations.GLANCEABILITY_OPEN_EDUCATIONAL_RESOURCE
      }
      return false
   }

   displayWarningGlanceability(secondaryResourceTypes: any) {
      return secondaryResourceTypes?.includes("retracted_publication") || secondaryResourceTypes?.includes("withdrawn_publication")
         || secondaryResourceTypes?.includes("retraction_notice") || secondaryResourceTypes?.includes("withdrawal_notice")
         || secondaryResourceTypes?.includes("publication_addendum") || secondaryResourceTypes?.includes("publication_corrigendum")
         || secondaryResourceTypes?.includes("publication_exp_concern")
   }

   getWarningGlanceabilityPublications(sourceType: any) {
      if (sourceType === "retracted_publication")
         return this.translationService.translations.GLANCEABILITY_RETRACTED_PUBLICATIONS
      if (sourceType === "withdrawn_publication")
         return this.translationService.translations.GLANCEABILITY_WITHDRAWN_PUBLICATIONS
      if (sourceType === "publication_addendum")
         return this.translationService.translations.GLANCEABILITY_PUBLICATION_ADDENDUM
      if (sourceType === "publication_corrigendum")
         return this.translationService.translations.GLANCEABILITY_PUBLICATION_CORRIGENDUM
      return false
   }

   getWarningGlanceabilityNotices(sourceType: any) {
      if (sourceType === "retraction_notice")
         return this.translationService.translations.GLANCEABILITY_RETRACTION_NOTICE
      if (sourceType === "withdrawal_notice")
         return this.translationService.translations.GLANCEABILITY_WITHDRAWAL_NOTICE
      if (sourceType === "publication_exp_concern")
         return this.translationService.translations.GLANCEABILITY_PUBLICATION_EXP_CONCERN
      return false
   }

   getDocumentGlancebilityIcon(sourceType: any) {
      if (sourceType === "review_article") {
         return 'reviewArticle'
      }
      if (sourceType === "primary_source") {
         return 'primarySource'
      }
      if (sourceType === "preprint") {
         return 'prePrint'
      }
      if (sourceType === "online_first") {
         return 'onlineFirstArticle'
      }
      if (sourceType === "open_educational_resource") {
         return 'openEducationalResource'
      }
      return false
   }

   checkGlanceabilityEnablmentFromCustomizer(){
      return this.config.data.document.enableGlanceability
   }

   displaySecondaryPublicationsTypesSeparator(index: number, typesList: any, type: any) {
      if (index == typesList.length - 1)
         return false
      const slicedArray = typesList.slice(index + 1)
      return !!(slicedArray.includes("retracted_publication") || slicedArray.includes("withdrawn_publication"))
   }

   displaySecondaryNoticeTypesSeparator(index: number, typesList: any, type: any) {
      if (index == typesList.length - 1)
         return false
      const slicedArray = typesList.slice(index + 1)
      return !!(slicedArray.includes("retraction_notice") || slicedArray.includes("withdrawal_notice"))
   }

   showVideoLink(doc: any) {
      return (doc.content_type === 'Streaming Video') && doc.uris?.length
   }

   // HACK: remove this once URIs are accessible via IEDL through API
   getVideoLink(doc: any) {
      if (doc.dbids.length !== _.difference(doc.dbids, this.docConfig.videoDBIDs).length) {
         return doc.uris[0]
      } else {
         return doc.link
      }
   }

   getDocumentSummary(doc: any) {
      const v = []
      switch (doc.content_type) {
         case 'Journal Article': // Publication, Date, Volume, Issue
            if (doc.publication_title != null) { v.push(doc.publication_title) }
            if (doc.publication_date != null) { v.push(this.localizeDate(doc.publication_date)) }
            if ((doc.volumes != null) && doc.volumes.length) { v.push(`${this.translationService.translations.VOLUME} ${doc.volumes[0]}`) }
            if ((doc.issues != null) && doc.issues.length) { v.push(`${this.translationService.translations.ISSUE} ${doc.issues[0]}`) }
            break
         case 'Book': case 'eBook': // Series Title, Year, Edition
            if (doc.publication_series_title != null) { v.push(doc.publication_series_title) }
            if ((doc.volumes != null) && doc.volumes.length) { v.push(`${this.translationService.translations.VOLUME} ${doc.volumes[0]}`) }
            if ((doc.publication_years != null) && doc.publication_years.length) { v.push(doc.publication_years[0]) }
            if ((doc.editions != null) && doc.editions.length) { v.push(doc.editions[0]) }
            break
         case 'Conference Proceedings': // Conference Name, Year
            if ((doc.meeting_names != null) && doc.meeting_names.length) { v.push(doc.meeting_names[0]) }
            if ((doc.volumes != null) && doc.volumes.length) { v.push(`${this.translationService.translations.VOLUME} ${doc.volumes[0]}`) }
            if ((doc.publication_years != null) && doc.publication_years.length) { v.push(doc.publication_years[0]) }
            break
         case 'Dissertation': // University, Year
            if ((doc.dissertation_schools != null) && doc.dissertation_schools.length) { v.push(doc.dissertation_schools[0]) }
            if ((doc.volumes != null) && doc.volumes.length) { v.push(`${this.translationService.translations.VOLUME} ${doc.volumes[0]}`) }
            if ((doc.publication_years != null) && doc.publication_years.length) { v.push(doc.publication_years[0]) }
            break
         case 'Newspaper Article': // Publication, Date, Page
            if (doc.publication_title != null) { v.push(doc.publication_title) }
            if ((doc.volumes != null) && doc.volumes.length) { v.push(`${this.translationService.translations.VOLUME} ${doc.volumes[0]}`) }
            if (doc.publication_date != null) { v.push(this.localizeDate(doc.publication_date)) }
            if (doc.pages != null) { v.push(doc.pages) }
            break
         default: // Publication, Date
            if (doc.publication_title != null) { v.push(doc.publication_title) }
            if ((doc.volumes != null) && doc.volumes.length) { v.push(`${this.translationService.translations.VOLUME} ${doc.volumes[0]}`) }
            if (doc.publication_date != null) { v.push(this.localizeDate(doc.publication_date)) }
      }
      return v.join(', ')
   }

   getSimpleTitle(docTitle: any) {
      return this.utils.removeHithighlightTags(docTitle)
   }

   getResearchResultDocument(doc: any) {
      if (!doc.thumbnail_small) { doc.thumbnail_small = false }
      if (!doc.thumbnail_medium) { doc.thumbnail_medium = false }
      if (!doc.thumbnail_large) { doc.thumbnail_large = false }

      // if the small thumbnail isn't available, try the larger versions
      if (!doc.thumbnail_small) { doc.thumbnail_small = doc.thumbnail_medium }
      if (!doc.thumbnail_small) { doc.thumbnail_small = doc.thumbnail_large }

      doc.hasDetailPage = this.displayDetailPage(doc) || this.displayAIPage(doc)
      doc.databases = this.quickLookService.setDatabases(doc)
      doc.simple_title = this.getSimpleTitle(doc.title)
      doc.journalCoverageSummary = this.journalCoverageDetailsService.getJournalCoverageSummary(doc)

      const hasIssns = doc.issns && doc.issns.length 
      if (hasIssns) {
         const issn = doc.issns[0]
         doc.eJournalLink = this.journalCoverageDetailsService.getJournalConverageDetailEJournalLink(this.configService.data.availability,issn)
      }
   
      if (doc.isAlmaClient) {
         const anyAlmaUrl = this.configService.data.alma.ill || this.configService.data.alma.suprima || this.configService.data.alma.citation_linker || this.configService.data.alma.journal_search
         if (anyAlmaUrl) {
            const almaBaseUrl = new URL(anyAlmaUrl).hostname
            const almaInstitutionCode = this.configService.data.results.almaId
            const ieId = doc.external_document_id
            return doc.eJournalLinkSOA = this.journalCoverageDetailsService.getJournalConverageDetailEJournalLinkSOA(almaBaseUrl,almaInstitutionCode,ieId)
         }
      }

      doc.display_thumbnail = !!(doc.thumbnail_small && doc.thumbnail_small !== '1x1')
      
      return doc
   }
}

DocumentService.$inject = ['configService', '$filter', 'translationService', 'utilitiesService', 'quickLookService', 'configService', 'journalCoverageDetailsService']

angular.module('summonApp.services')
   .service('documentService', DocumentService)
